import { first } from 'rxjs/operators';
import { Report } from './../../model/settings.model';
import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Vehicle } from '../../model/vehicle.model';
import { VehicleService } from '../../service/vehicle.service';
import { Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery';
import { ToastService } from '../../service/toast.service';
import { ParametersService } from '../../service/parameters.service';
import { VehicleSettings } from '../../model/settings.model';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: "app-vehicle",
  templateUrl: "./vehicle.component.html",
  styleUrls: ["./vehicle.component.less"],
})
export class VehicleComponent implements OnInit, OnChanges {
  vehicleForm: FormGroup;
  vehicle: Vehicle;
  @Input() vehicleId: string;
  @Input() tchekId: string;
  @Output() newClassEmitter = new EventEmitter<string>();
  timerEvent: NodeJS.Timer;
  selectedClass: string;
  vehicleSettings: VehicleSettings;

  constructor(
    private readonly _vehicleService: VehicleService,
    private readonly _toastService: ToastService,
    private readonly _parametersService: ParametersService
  ) {
    this.vehicleSettings = this._parametersService.getAll().vehicle;
    this.vehicleForm = new FormGroup({
      immat: new FormControl(""),
      brand: new FormControl(""),
      or: new FormControl(""),
      vin: new FormControl(""),
      model: new FormControl(""),
    });
  }

  ngOnInit() {}

  ngOnDestroy() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.vehicleId.currentValue) {
      this._vehicleService
        .get(changes.vehicleId.currentValue)
        .then((vehicle) => {
          this.vehicle = vehicle;
          this.selectedClass = this.vehicle.class;
          this.vehicleForm.setValue({
            immat: this.vehicle.immat.toLocaleUpperCase() || "",
            brand: this.vehicle.brand || "",
            model: this.vehicle.model || "",
            or: this.vehicle.or ? this.vehicle.or.toLocaleUpperCase() : "",
            vin: this.vehicle.vin ? this.vehicle.vin.toLocaleUpperCase() : "",
          });
          this.vehicleForm.valueChanges.subscribe((newValues) => {
            this.vehicle.immat = newValues.immat.toLocaleUpperCase();
            this.vehicle.brand = newValues.brand;
            this.vehicle.model = newValues.model;
            this.vehicle.or = newValues.or.toLocaleUpperCase();
            this.vehicle.vin = newValues.vin.toLocaleUpperCase();
            this.sendData();
          });
        });
    }
  }

  loadComponent() {
    this._vehicleService.get(this.vehicleId).then((vehicle) => {
      this.vehicle = vehicle;
      this.selectedClass = this.vehicle.class;
      this.vehicleForm.setValue({
        immat: this.vehicle.immat.toLocaleUpperCase() || "",
        brand: this.vehicle.brand || "",
        model: this.vehicle.model || "",
        or: this.vehicle.or ? this.vehicle.or.toLocaleUpperCase() : "",
        vin: this.vehicle.vin ? this.vehicle.vin.toLocaleUpperCase() : "",
      });
      this.vehicleForm.valueChanges.subscribe((newValues) => {
        this.vehicle.immat = newValues.immat.toLocaleUpperCase();
        this.vehicle.brand = newValues.brand;
        this.vehicle.model = newValues.model;
        this.vehicle.or = newValues.or.toLocaleUpperCase();
        this.vehicle.vin = newValues.vin.toLocaleUpperCase();
        this.sendData();
      });
    });
  }

  handlerChangeClassName(event: string) {
    this.newClassEmitter.emit(event);
    this.sendData();
  }

  sendData() {
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      this._toastService.toastOpen(true);
      this._vehicleService
        .saveVehicle(
          this.vehicle.id,
          this.vehicle.immat,
          this.vehicle.brand,
          this.vehicle.model,
          this.vehicle.or,
          this.vehicle.vin,
          this.selectedClass,
          this.tchekId
        )
        .then((savedVehicle: Vehicle) => {
          this.vehicle = savedVehicle[0];
          this.newClassEmitter.emit(this.selectedClass);
          this._toastService.toastOpen(false);
        });
    }, 800);
  }
}




// WEBPACK FOOTER //
// ./src/app/element/vehicle/vehicle.component.ts